import { render } from "./ProductModelSelect.vue?vue&type=template&id=526c4846&scoped=true"
import script from "./ProductModelSelect.vue?vue&type=script&lang=js"
export * from "./ProductModelSelect.vue?vue&type=script&lang=js"

import "./ProductModelSelect.vue?vue&type=style&index=0&id=526c4846&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526c4846"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QIcon,QList});qInstall(script, 'directives', {ClosePopup});
